/**
 * PublicFilterChips — filter <select> dropdowns for public list pages.
 * Renders one compact dropdown per filterable field; designed to sit inline
 * in the toolbar row. The parent wraps them in a scrollable container.
 */

import React, { useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function PublicFilterChips({ fields = [], onFilter }) {
  const [active, setActive] = useState({});
  const { theme } = useTheme();
  const accentColor = theme.primary;

  if (!fields.length) return null;

  const handleChange = (fieldName, value) => {
    const next = { ...active };
    if (!value) {
      delete next[fieldName];
    } else {
      next[fieldName] = value;
    }
    setActive(next);
    const filters = {};
    Object.entries(next).forEach(([k, v]) => {
      filters[`filter[${k}]`] = v;
    });
    onFilter(filters);
  };

  return (
    <>
      {fields.map((field) => {
        const options = field.options || (field.data_type === 'boolean' ? ['true', 'false'] : []);
        if (!options.length) return null;
        const isActive = !!active[field.name];
        return (
          <select
            key={field.name}
            style={{
              fontSize: '0.8rem',
              borderRadius: 'var(--button-radius)',
              border: `1.5px solid ${isActive ? accentColor : '#e2e8f0'}`,
              color: isActive ? accentColor : '#64748b',
              fontWeight: isActive ? 600 : 400,
              background: isActive ? `${accentColor}12` : '#fff',
              minWidth: 120,
              maxWidth: 170,
              flexShrink: 0,
              padding: '5px 28px 5px 12px',
              outline: 'none',
              cursor: 'pointer',
              boxShadow: isActive
                ? `0 0 0 3px ${accentColor}18`
                : '0 1px 3px rgba(0,0,0,0.06)',
              transition: 'border-color 200ms ease, color 200ms ease, background 200ms ease, box-shadow 200ms ease',
              appearance: 'auto',
            }}
            value={active[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
          >
            <option value="">{field.display_name}</option>
            {options.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        );
      })}
    </>
  );
}
